// Shared video helpers — one parser used everywhere videos are read (profile,
// card label, signup validation). Handles every YouTube URL shape we store:
// youtube.com/watch?v=ID (params in any order), youtu.be/ID, youtube.com/embed/ID,
// youtube.com/v/ID, youtube.com/shorts/ID, plus m.youtube.com / music.youtube.com
// and any ?si= or extra query params.
export const getYouTubeId = (url) => {
  if (!url) return null;
  const s = String(url);
  const m =
    s.match(/[?&]v=([^&\s]+)/) ||
    s.match(/youtu\.be\/([^?&\s/]+)/) ||
    s.match(/youtube\.com\/embed\/([^?&\s/]+)/) ||
    s.match(/youtube\.com\/v\/([^?&\s/]+)/) ||
    s.match(/youtube\.com\/shorts\/([^?&\s/]+)/);
  return m ? m[1] : null;
};

export const youtubeThumb = (url) => {
  const id = getYouTubeId(url);
  return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : null;
};

export const isInstagram = (url) => /instagram\.com/i.test(url || '');

// A YouTube Short (vertical 9:16) vs a regular video.
export const isYouTubeShort = (url) => /youtube\.com\/shorts\//i.test(url || '');

// A link we can show as a video tile (YouTube thumbnail or an Instagram reel).
export const isPlayableVideo = (url) => Boolean(getYouTubeId(url) || isInstagram(url));
